import { FieldInputProps, FormikProps } from 'formik';
import FormFieldMessage from '../../common/FormFieldMessage';
import Input from '../../common/Input';
import Textarea from '../../common/Textarea';
import ValidationErrorSvg from '../../../assets/ValidationError.svg';
import './TextAnswer.css';

export type TextAnswerProps = {
  field: FieldInputProps<any>;
  form: (string | undefined) & FormikProps<any>;
  placeholderText: string;
  subText: string;
  lines: number;
};

const TextAnswer = ({ field, form, placeholderText, subText, lines }: TextAnswerProps) => {
  const isInvalid = () => form.touched[field.name] && form.errors[field.name];
  const composeAnswer = () => lines > 1   
    ? <Textarea
        field={field}
        form={form}
        placeholder={placeholderText}
        className='text-answer'
        rows={lines}
      />
    : <Input
        field={field}
        form={form}
        placeholder={placeholderText}
        type='text'
        className='text-answer'
        suppressValidation={true}
      />;
  
  return (
    <>
      { composeAnswer() }
      {
        subText && 
          <div className='text-answer-sub-text-container'>
            <span className='text-answer-sub-text'>{subText}</span>
          </div>
      }
      {
        isInvalid() && 
          <div className='question-answer-validation'>
            <img src={ValidationErrorSvg} alt='Validation' />
            <FormFieldMessage text={form.errors[field.name]} />
          </div>
      }
    </>
  );
};

export default TextAnswer;